import RebutFIltre from "../../../model/multilleure/rebuts/RebutFIltre";

const apiUrl = process.env.REACT_APP_API_URL;
export const GetRebuts = async ( page : string, rebutFiltre : RebutFIltre) => {
    try {
        const response = await fetch(`${apiUrl}:8073/rebuts/getAll`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'pantalla': page
            },
            body: JSON.stringify(rebutFiltre)
        });
        const jsonData = await response.json();
        return jsonData;
    } catch (error) {
        console.log('Error al obtener los datos:', error);
    }
};
